// TODO: Have a idl_config.json parser, to load up intents here automatically
// Maybe just hook into the GCS json file
export const Type = {
  ADD_DIAGNOSIS: 'ADD_DIAGNOSIS',
  AGENT_CANCELLED: 'AGENT_CANCELLED',
  AGENT_PROCESSING: 'AGENT_PROCESSING',
  AGENT_WAKEUP: 'AGENT_WAKEUP',
  CHANGE: 'SCRIPT_CHANGE',
  COPY_FORWARD: 'COPY_FORWARD',
  CREATE_NOTE_FROM_NOTETYPE_FOR_PATIENT: 'CREATE_NOTE_FROM_NOTETYPE_FOR_PATIENT',
  DELETE_NOTE: 'DELETE_NOTE',
  DISMISS: 'DISMISS',
  GO_BACK: 'GO_BACK',
  GOTO_HOME: 'GOTO_HOME',
  GOTO_LIST: 'GOTO_LIST',
  GOTO_NOTETYPES: 'GOTO_NOTETYPES',
  GOTO_PATIENTS: 'GOTO_PATIENTS',
  GOTO_SETTINGS: 'GOTO_SETTINGS',
  HELP: 'HELP',
  LOG_OUT: 'LOG_OUT',
  MACRO: 'MACRO', // only required for transcription mode commands/silence detection disabling
  PRINT_NOTE: 'PRINT_NOTE',
  PROFILE: 'PROFILE',
  SCHEDULE: 'SCHEDULE',
  SECTION: 'SECTION',
  SHOW_SCRIPTS: 'SHOW_SCRIPTS',
  SHOW_MEDICATIONS: 'SHOW_MEDICATIONS',
  START_DICTATION: 'START_DICTATION',
  STOP_DICTATION: 'STOP_DICTATION',
  SUBMIT_NOTE: 'SUBMIT_NOTE',
  UNFINISHED_NOTES: 'UNFINISHED_NOTES',
  URINE_CULTURE: 'URINE_CULTURE',
  VEIN_MAPPING: 'VEIN_MAPPING',
  WHAT_CAN_I_SAY: 'WHAT_CAN_I_SAY',
  XRAY: 'XRAY'
}

class IntentEvent {
  constructor (timestamp, type, value) {
    this.timestamp = timestamp
    this.type = type
    this.value = value
  }
}

export default IntentEvent
